import * as React from "react";
import { ComboBox } from "@/components/ui/combo-box";
import type { InvoicePublic } from "./schema";

const getMonthName = (monthNumber: number): string => {
  const date = new Date();
  date.setMonth(monthNumber - 1); // Month is 0-indexed in Date
  return date.toLocaleString("en-US", { month: "long" });
};

interface InvoiceData {
  data?: InvoicePublic[];
}

type MonthValue = number; // Month are 1-indexed in the database

interface SelectMonthComboBoxProps {
  value: MonthValue | null;
  onChange: (value: MonthValue | null) => void;
  data: InvoiceData | undefined;
  isLoading?: boolean;
  placeholder?: string;
  triggerClassName?: string;
  contentClassName?: string;
}

export function SelectMonthComboBox({
  value,
  onChange,
  data,
  isLoading = false,
  placeholder = "Month",
  triggerClassName,
  contentClassName,
}: SelectMonthComboBoxProps) {
  const months = React.useMemo(() => {
    if (!data?.data) return [];
    const uniqueMonths = new Set(data.data.map((invoice) => invoice.month).filter((m) => m >= 1 && m <= 12));
    return Array.from(uniqueMonths)
      .sort((a, b) => a - b)
      .map((month) => ({
        value: month,
        label: getMonthName(month),
      }));
  }, [data]);

  return (
    <ComboBox<MonthValue>
      options={months}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchPlaceholder="Search month..."
      emptyMessage="No month found."
      isLoading={isLoading || !data}
      triggerClassName={triggerClassName}
      contentClassName={contentClassName}
      allowClear
    />
  );
}
